import { render } from "./ControleCobrancasImobiliariasView.vue?vue&type=template&id=0ba58a35&scoped=true"
import script from "./ControleCobrancasImobiliariasView.vue?vue&type=script&lang=js"
export * from "./ControleCobrancasImobiliariasView.vue?vue&type=script&lang=js"

import "./ControleCobrancasImobiliariasView.vue?vue&type=style&index=0&id=0ba58a35&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba58a35"]])

export default __exports__